import React from "react"

import FieldHelp from "../../../help-and-hint/field-help/field-help"

type Props = {
    menuParams: {
        highlightClass      : string
        option              : Option
        isHighlighted       : boolean
        selectedValue       : string
        showButtonSelection : boolean
        onClick             : callback
    }
    disabled    : boolean
    hidePopover : callback
}

// const debug = "PopoverMenuOptionButton"
const debug = false

export default function PopoverMenuOptionButton(state: any, props: Props) {
    const selectedOption = props.menuParams.showButtonSelection ? _.find(props.menuParams.option.options, option=>option.value === props.menuParams.selectedValue) : null

    const option = selectedOption || props.menuParams.option

    const classes = Classes('option', {
        'disabled'                          : props.disabled,
        'with-icon'                         : !!option.icon,
        'selected'                          : props.menuParams.showButtonSelection && !!selectedOption,
        'highlighted'                       : props.menuParams.isHighlighted,
        [props.menuParams.highlightClass]   : props.menuParams.isHighlighted,
    })

    let icon    = option.icon
    let label   = option.label
    if (option.showLabelFromSelectedOption) {
        const selectedOption = _.find(props.menuParams.option.options, (option: Option)=>option.isSelected) as Option
        if (selectedOption) {
            // if (selectedOption.icon) icon = selectedOption.icon
            label = selectedOption.label
        }
    }

    debug && console.log(debug, 'render', option, state, props)

    return (
        <div className={classes}>
            {option.icon && <div className={Classes("ico", icon)}/>}
            {option.iconComponent}
            <div className="label">{label}</div>

            {!!option.hint &&
                <div className="flex-row-right-center flex-1">
                    <FieldHelp className="option-hint m-l-8" message={option.hint}/>
                </div>}

            <div className="submenu-arrow i5-big-angle-right"/>
        </div>
    )
}